"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeStencilComponent = composeStencilComponent;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _testAttributes = require("./testAttributes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function composeStencilComponent(_ref) {
  var baseComponent = _ref.baseComponent,
      dataTestComponent = _ref.dataTestComponent,
      displayName = _ref.displayName,
      description = _ref.description,
      defaultProps = _ref.defaultProps,
      propTypes = _ref.propTypes;
  // Wrapping base component with describe HoC.
  var ComponentWithDocs = (0, _stencilReactDesc.describe)(baseComponent).description(description); // Adding prop-types with description

  if (propTypes) {
    ComponentWithDocs.propTypes = _objectSpread({}, propTypes);
  } // Adding defaultProps values


  if (defaultProps) {
    ComponentWithDocs.defaultProps = _objectSpread({}, defaultProps);
  } // Adding test attributes (data-test-component, data-test-id)


  var Component = (0, _testAttributes.withTestAttributes)({
    component: dataTestComponent || "Stencil".concat(displayName)
  })(ComponentWithDocs); // Naming components

  Component.displayName = displayName;
  ComponentWithDocs.displayName = "described(".concat(displayName, ")");
  return Component;
}